import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const SITE_URL = process.env.REACT_APP_SITE_URL || (typeof window !== "undefined" ? window.location.origin : "");

export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

export function errorMessage(e, fallback = "Something went wrong. Please try again.") {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}
